export default __webpack_public_path__ + "static/heroImg-680325d06661c1b7002674cc975b380a.png";